<template>
    <div>
        <div class="row">
            <breadcrumb>
                <template v-slot:1>
                    <router-link :to="{ name: 'informes' }">{{
                            $t("informes")
                    }}</router-link>
                </template>
                <template v-slot:2>{{ $t("desglosesImpuestos") }}</template>
            </breadcrumb>

            <CabeceraInformes :idBusiness="idBusiness" :listBusinesses="listBusinesses" :idTpv="idTpv"
                :listTpv="listTpv" :dateto="dateto" :datefrom="datefrom" id="cabecera" :conTodos="true" />
            <template v-if="!permiso">
                <div class="alert alert-danger m-3" style="width: 100%" role="alert">
                    Lo sentimos. Este negocio no cuenta con este módulo activado.
                </div>
            </template>
            <div class="col-md-12" v-else-if="respuesta">
                <template v-if="dateInform.length > 0">
                    <div class="row justify-content-between div-export">
                        <div class="col-md-12  text-left">
                            <el-dropdown>
                                <el-button type="primary" size="small">
                                    <i class="fa fa-file"></i>
                                    {{ $t("exportarInforme") }}
                                    <i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <a :href="urlExportPDF">
                                        <el-dropdown-item class="text-danger">
                                            <strong><i class="fa fa-file-pdf"></i>
                                                {{ $t("exportarPdf") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcel">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i>
                                                {{ $t("exportarExcel") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                    <a :href="urlExportExcelValderrama" v-if="tienePropinaYServiceCharge">
                                        <el-dropdown-item class="text-success">
                                            <strong><i class="fa fa-file-excel"></i>
                                                {{ $t("exportarExcelValderrama") }}</strong>
                                        </el-dropdown-item>
                                    </a>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>

                    <div class="table-responsive" style="overflow: auto">
                        <table class="table table-bordered table-striped text-nowrap">
                            <thead class="thead-dark">
                                <tr>
                                    <th>
                                        <span v-if="ordenarFecha" @click="sortedArrayASC(1), (ordenarFecha = 0)"><i
                                                style="color: white" class="fa fa-angle-up"></i>
                                            {{ $t("fecha") }}
                                        </span>
                                        <span v-else @click="sortedArrayDESC(1), (ordenarFecha = 1)"><i
                                                style="color: white" class="fa fa-angle-down"></i>
                                            {{ $t("fecha") }}
                                        </span>
                                    </th>

                                    <th>{{ $t("base") }}</th>
                                    <th>{{ $t("impuesto") }}</th>
                                    <th>{{ $t("total") }}</th>
                                    <th v-if="tienePropinaYServiceCharge">{{ $t("basePropina") }}</th>
                                    <th v-if="tienePropinaYServiceCharge">{{ $t("impuestoPropina") }}</th>
                                    <th v-if="tienePropinaYServiceCharge">{{ $t("propina") }}</th>
                                    <th v-if="tienePropinaYServiceCharge">{{ $t("baseServiceCharge") }}</th>
                                    <th v-if="tienePropinaYServiceCharge">{{ $t("impuestoServiceCharge") }}</th>
                                    <th v-if="tienePropinaYServiceCharge">{{ $t("serviceCharge") }}</th>
                                    <th v-if="tienePropinaYServiceCharge">{{ $t("totalCompleto") }}</th>
                                    <th>{{$t("primerTicket")}}</th>
                                    <th>{{$t("ultimoTicket")}}</th>
                                    <th>{{ $t("acciones") }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(det, index) in dateInform">
                                    <td>
                                        <span :class="getClassDay(det.day)">{{ det.day | getDia }} {{ det.day |
                                                parseDate
                                        }}</span>
                                    </td>
                                    <td align="right">{{ getTotalBase(index) | currency }}</td>
                                    <td align="right">
                                        {{ getTotalImpuesto(index) | currency }}
                                    </td>
                                    <td align="right">{{ getTotal(index) | currency }}</td>
                                    <td align="right" v-if="tienePropinaYServiceCharge"> {{ getTotalBasePropina(index) | currency }} </td>
                                    <td align="right" v-if="tienePropinaYServiceCharge"> {{ getTotalImpuestoPropina(index) | currency }} </td>
                                    <td align="right" v-if="tienePropinaYServiceCharge"> {{ getTotalPropina(index) |
                                            currency
                                    }} </td>
                                    <td align="right" v-if="tienePropinaYServiceCharge"> {{ getTotalBaseServiceCharge(index) | currency}} </td>
                                    <td align="right" v-if="tienePropinaYServiceCharge"> {{ getTotalImpuestoServiceCharge(index) | currency}} </td>
                                    <td align="right" v-if="tienePropinaYServiceCharge"> {{ getTotalServiceCharge(index)
                                            |
                                            currency
                                    }} </td>
                                    <td align="right" v-if="tienePropinaYServiceCharge"> {{ getTotalCompleto(index)
                                            |
                                            currency
                                    }} </td>
                                    <td align="right">
                                        {{ det.firstTicket }}
                                    </td>
                                    <td align="right">
                                        {{det.lastTicket }}
                                    </td>
                                    <td align="center">
                                        <i @click="openModal(index)" v-tooltip.top-center="$t('desglose')"
                                            class="fa fa-info-circle"></i>
                                    </td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr class="table-success">
                                    <td>
                                        <strong>{{ $t("total") }}:</strong>
                                    </td>
                                    <td class="text-right">
                                        <strong>
                                            {{ getTotalBases | currency }}
                                        </strong>
                                    </td>
                                    <td class="text-right">
                                        <strong>
                                            {{ getTotalImpuestos | currency }}
                                        </strong>
                                    </td>
                                    <td class="text-right">
                                        <strong>
                                            {{ getTotalTotales | currency }}
                                        </strong>
                                    </td>
                                    <td class="text-right" v-if=tienePropinaYServiceCharge> 
                                        <strong>
                                            {{ getTotalBasesPropinas | currency }}
                                        </strong> 
                                    </td>
                                    <td class="text-right" v-if=tienePropinaYServiceCharge> 
                                        <strong>
                                            {{ getTotalImpuestosPropinas | currency }}
                                        </strong> 
                                    </td>
                                    <td class="text-right" v-if=tienePropinaYServiceCharge> 
                                        <strong>
                                            {{ getTotalPropinas | currency }}
                                        </strong> 
                                    </td>
                                    <td class="text-right" v-if=tienePropinaYServiceCharge> 
                                        <strong>
                                            {{ getTotalBasesServiceCharges | currency }}
                                        </strong> 
                                    </td>
                                    <td class="text-right" v-if=tienePropinaYServiceCharge> 
                                        <strong>
                                            {{ getTotalImpuestosServiceCharges | currency }}
                                        </strong> 
                                    </td>
                                    <td class="text-right" v-if=tienePropinaYServiceCharge> 
                                        <strong>
                                            {{ getTotalServiceCharges | currency }}
                                        </strong> 
                                    </td>
                                    <td class="text-right" v-if=tienePropinaYServiceCharge> 
                                        <strong>
                                            {{ getTotalTotalesCompleto | currency }}
                                        </strong> 
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </template>
                <template v-else>
                    <div class="alert alert-danger" role="alert">
                        {{ $t("noHayVentasEnEsteRangoDeFechas") }}
                    </div>
                </template>
            </div>
        </div>

        <modal name="desgloseModal" :adaptive="true" :scrollable="true" height="auto" :clickToClose="false">
            <div>
                <div class="modal-header">
                    <h4>{{ $t("desglosesImpuestos") }}</h4>
                </div>
                <div class="modal-body">
                    <template v-if="listIva.length > 0">
                        <div class="table-responsive" style="overflow: auto">
                            <table class="table table-bordered table-striped ">
                                <thead class="thead-dark">
                                    <tr>
                                        <th>{{ $t("tipo") }}</th>
                                        <th>{{ $t("base") }}</th>
                                        <th>{{ $t("impuesto") }}</th>
                                        <th>{{ $t("total") }}</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="i in listIva">
                                        <td>{{ i.iva }}</td>
                                        <td align="right">{{ i.Bases | currency }}</td>
                                        <td align="right">{{ i.Impuestos | currency }}</td>
                                        <td align="right">{{ i.Totales | currency }}</td>


                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr></tr>
                                </tfoot>
                            </table>
                        </div>
                    </template>
                    <template v-else>
                        <table class="table table-bordered table-striped ">
                            <tbody>
                                <tr>
                                    <td class="alert alert-danger" align="center" colspan="4">
                                        <strong>{{ $t("noExisteDesgloseImpuestos") }}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-default" @click="cerrarModal()">
                        <i class="fa fa-times-circle"></i> {{ $t("volver") }}
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import {
    DatePicker,
    Select,
    Option,
    Dropdown,
    DropdownItem,
    Loading,
    DropdownMenu,
    Button,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import Datetime from "vue-datetime";
import Breadcrumb from "@/components/Breadcrumb/Breadcrumb.vue";
import CabeceraInformes from "@/components/CabeceraInformes/CabeceraInformes.vue";
import { mapState } from 'vuex'

export default {
    created() {
        this.loading = Loading.service({ text: "Cargando..." });
        this.$store.dispatch("setNameRoute", "Impuestos por cierre de caja");
        this.getBusiness();

        if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
            this.datefrom = this.$store.getters.dateFrom;
            this.dateto = this.$store.getters.dateTo;
        }
    },
    components: {
        [DatePicker.name]: DatePicker,
        [Select.name]: Select,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Button.name]: Button,
        [Datetime]: Datetime,
        [Option.name]: Option,
        Breadcrumb,
        CabeceraInformes,
    },
    data() {
        return {
            loading: false,
            datefrom: new Date(
                new Date().getFullYear(),
                new Date().getMonth(),
                1
            ).toISOString(),
            dateto: new Date().toISOString(),
            listBusinesses: [],
            idBusiness: 0,
            value4: [
                new Date(new Date().getFullYear(), new Date().getMonth(), 1),
                new Date(),
            ],
            data: [""],
            idTpv: 0,
            listTpv: [],
            cuentasAparcadas: false,
            dateInform: ["-"],
            index: 0,
            tipo0: null,

            listIva: [],
            tienePropinaYServiceCharge: false,

            //ORDENAR
            ordenarFecha: 0,
            ordenarBase: 0,
            ordenarImpuesto: 0,
            ordenarTotal: 0,

            respuesta: true,
        };
    },
    computed: {
        ...mapState(["permiso"]),
        urlExportPDF() {

            let idTpvAMandar = "";
            if (this.idTpv == -1) {
                idTpvAMandar = 0;
            } else {
                idTpvAMandar = this.idTpv;
            }

            return (
                this.$store.getters.apiUrl +
                "/sales/exportDesglosesImpuestos/PDF?idTpv=" +
                idTpvAMandar +
                "&idBusiness=" +
                this.idBusiness +
                "&datefrom=" +
                moment(this.datefrom)
                    .startOf("day")
                    .unix() +
                "&dateto=" +
                moment(this.dateto)
                    .endOf("day")
                    .unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );
        },
        urlExportExcel() {

            let idTpvAMandar = "";
            if (this.idTpv == -1) {
                idTpvAMandar = 0;
            } else {
                idTpvAMandar = this.idTpv;
            }

            return (
                this.$store.getters.apiUrl +
                    "/sales/exportDesglosesImpuestos/Excel?idTpv=" +
                idTpvAMandar +
                    "&idBusiness=" +
                this.idBusiness +
                    "&datefrom=" +
                moment(this.datefrom)
                    .startOf("day")
                    .unix() +
                "&dateto=" +
                moment(this.dateto)
                    .endOf("day")
                    .unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );
        },
        urlExportExcelValderrama() {
            let idTpvAMandar = "";
            if (this.idTpv == -1) {
                idTpvAMandar = 0;
            } else {
                idTpvAMandar = this.idTpv;
            }

            return (
                this.$store.getters.apiUrl +
                    "/sales/exportDesglosesImpuestosValderrama?idTpv=" +
                idTpvAMandar +
                    "&idBusiness=" +
                this.idBusiness +
                    "&datefrom=" +
                moment(this.datefrom)
                    .startOf("day")
                    .unix() +
                "&dateto=" +
                moment(this.dateto)
                    .endOf("day")
                    .unix() +
                "&jwt=" +
                this.$store.getters.jwt
            );
        },
        getTotalBases() {
            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalBase(ind);
            });
            return total;
        },
        getTotalImpuestos() {
            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalImpuesto(ind);
            });
            return total;
        },
        getTotalTotales() {
            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotal(ind);
            });
            return total;
        },
        getTotalBasesPropinas() {

            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalBasePropina(ind);
            });
            return total;

        },
        getTotalImpuestosPropinas() {

            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalImpuestoPropina(ind);
            });
            return total;

        },
        getTotalPropinas() {

            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalPropina(ind);
            });
            return total;

        },
        getTotalBasesServiceCharges() {

            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalBaseServiceCharge(ind);
            });
            return total;

        },
        getTotalImpuestosServiceCharges() {

            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalImpuestoServiceCharge(ind);
            });
            return total;

        },
        getTotalServiceCharges() {

            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalServiceCharge(ind);
            });
            return total;

        },
        getTotalTotalesCompleto() {
            let total = 0;
            let vm = this;
            this.dateInform.forEach(function (det, ind) {
                total += vm.getTotalCompleto(ind);
            });
            return total;
        },
    },
    methods: {
        sortedArrayASC: function (nameAtributo) {
            switch (nameAtributo) {
                case 1:
                    this.ordenarFecha = 1;

                    function compareDate(a, b) {
                        if (a.day.toUpperCase() < b.day.toUpperCase()) return -1;
                        if (a.day.toUpperCase() > b.day.toUpperCase()) return 1;
                        return 0;
                    }

                    return this.dateInform.sort(compareDate);
            }
        },
        sortedArrayDESC: function (nameAtributo) {
            switch (nameAtributo) {
                case 1:
                    this.ordenarFecha = 0;

                    function compareFecha(a, b) {
                        if (a.day.toUpperCase() > b.day.toUpperCase()) return -1;
                        if (a.day.toUpperCase() < b.day.toUpperCase()) return 1;
                        return 0;
                    }

                    return this.dateInform.sort(compareFecha);
            }
        },

        // getIva(index) {

        //     var config = {
        //         params: {
        //             idBusiness: this.idBusiness,
        //             jwt: this.$store.getters.jwt
        //         },
        //         headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
        //     };

        //     let vm = this;
        //     if(!(this.dateInform[index].data == null)){
        //     this.dateInform[index].data.forEach(function (d) {

        //             if(d.Totales != 0){
        //                 vm.listIva.push(1);
        //             }else{
        //                 vm.listIva.push(0);
        //             }

        //     }

        //     )

        //     }

        // },

        getIva(index) {
            let vm = this;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    if (d.Totales != 0) {
                        vm.listIva.push(d);
                    }
                });
            }
        },

        // getTotalHeader(index, iva) {
        //     // let total = 0;
        //     // let tipo = null;
        //     // let baseT = null;
        //     // let impuestoT = null;

        //     // this.dateInform[this.index].headers.forEach(function (d) {

        //     //     for (let i = 0; i < d.details.length; i++) {

        //     //         if (d.details[i].vatType === parseFloat(iva)) {
        //     //             total += d.details[i].amount;
        //     //             baseT += d.details[i].base;
        //     //             impuestoT += d.details[i].valor;
        //     //         }
        //     //     }
        //     // });

        //     console.log('Indice Cierres', index);
        //     console.log('Posicion IVA', iva);

        //     let tipo = null;

        //     if (this.dateInform[index].data[iva]) {
        //         console.log(this.dateInform[index].data[iva]);
        //         tipo = {
        //             iva: this.dateInform[index].data[iva]["iva"],
        //             amount: this.dateInform[index].data[iva]["Totales"],
        //             base: this.dateInform[index].data[iva]["Bases"],
        //             valor: this.dateInform[index].data[iva]["Impuestos"],
        //         }
        //     }

        //     return tipo;

        // },

        getTotal(index) {
            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.Totales;
                    
                });
            }
            return total;
        },
        getTotalBase(index) {
            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.Bases;
                });
            }
            return total;
        },
        getTotalImpuesto(index) {
            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.Impuestos;
                });
            }
            return total;
        },

        getTotalBasePropina(index) {

            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.Propinas / (1 + (d.iva / 100));
                });
            }

            return total;
        },

        getTotalImpuestoPropina(index) {

            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.Propinas - (d.Propinas / (1 + (d.iva / 100)));
                });
            }

            return total;
        },

        getTotalPropina(index) {

            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.Propinas;
                });
            }

            return total;
        },

        getTotalBaseServiceCharge(index) {
            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.ServiceCharge / (1 + (d.iva / 100));
                });
            }

            return total;
        },

        getTotalImpuestoServiceCharge(index) {
            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.ServiceCharge - (d.ServiceCharge / (1 + (d.iva / 100)));
                });
            }

            return total;
        },

        getTotalServiceCharge(index) {
            let total = 0;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.ServiceCharge;
                });
            }

            return total;
        },

        getTotalCompleto(index){

                let total = 0;
                let vm = this;
            if (this.dateInform[index].data) {
                this.dateInform[index].data.forEach(function (d) {
                    total += d.Totales + d.Propinas + d.ServiceCharge;
                });
            }

            return total;
        },

        getBusiness() {
            var config = {
                params: {
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
                .then(function (response) {


                    vm.listBusinesses = response.data.result;

                    if (vm.$store.getters.idBusiness) {
                        vm.idBusiness = vm.$store.getters.idBusiness;
                    } else {
                        vm.idBusiness = response.data.result[0].id;
                    }


                    vm.cambioTpv(-1, false);

                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        openModal(indice) {
            this.index = indice;

            let vm = this;

            vm.getIva(this.index);
            // console.log('Lista IVAs', this.listIva);

            // if(this.listIva.length>0){
            this.$modal.show("desgloseModal");
            // }else{
            //Modal no hay desgloses?
            // }
        },

        cerrarModal() {
            this.indice = 0;
            this.index = 0;

            this.$modal.hide("desgloseModal");
            let vm = this;
            this.listIva = [];
        },

        cambioBusiness(idBusinessData, listTpv) {

            if (listTpv) {
                this.listTpv = listTpv;
            }
            this.loading = Loading.service({ text: "Cargando..." });
            this.idBusiness = idBusinessData;
            this.idTpv = -1;
            this.list = [];
            this.cambioTpv()
        },
        emitirConsulta() {
            this.loadingGeneral = Loading.service({ text: this.$t('cargando') });
            this.getDesglosesImpuestos();

        },
        cambioTpv(idTpvData, filtrar) {

            this.getConfigTpv();
            if (idTpvData != undefined) {

                this.idTpv = idTpvData;
            }
            this.emitirConsulta();
        },
        cambioHora(dates) {
            this.datefrom = dates[0];
            this.dateto = dates[1];
        },

        getTpv() {
            this.listTpv = [];

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.axios
                .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
                .then(function (response) {
                    if (response.data.response) {
                        vm.listTpv = response.data.result;
                        if (vm.listTpv.length > 0) {
                            vm.idTpv = vm.listTpv[0].id;
                            vm.getDesglosesImpuestos();
                        }
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally((_) => {
                    vm.loading.close();
                });
        },

        //Comprueba si el negocio tiene propina y service charge para mostrarlo en la tabla
        getConfigTpv() {

            var configPropinaServiceCharge = 92;

            var config = {
                params: {
                    idBusiness: this.idBusiness,
                    jwt: this.$store.getters.jwt,
                    numConfig: configPropinaServiceCharge,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
                .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                .then(function (response) {

                    vm.tienePropinaYServiceCharge = response.data.response;

                })
                .catch(function (error) {
                    console.log(error);
                });
        },


        getDesglosesImpuestos() {
            if (this.datefrom === null || this.dateto === null) {
                swal({
                    title: this.$t("ups"),
                    text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                });
            } else {
                let secondsDesde = moment(this.datefrom).unix();
                let secondsHasta = moment(this.dateto).unix();

                if (secondsHasta < secondsDesde) {
                    swal({
                        title: this.$t("ups"),
                        text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
                        confirmButtonClass: "btn btn-info btn-fill",
                        type: "error",
                    });
                } else {
                    this.$store.dispatch("setDateTo", this.dateto);
                    this.$store.dispatch("setDateFrom", this.datefrom);

                    this.loading = Loading.service({ text: "Cargando..." });

                    let idTpvAMandar = "";
                    if (this.idTpv == -1) {
                        idTpvAMandar = 0;
                    } else {
                        idTpvAMandar = this.idTpv;
                    }

                    var config = {
                        params: {
                            idTpv: idTpvAMandar,
                            idBusiness: this.idBusiness,
                            datefrom: moment(this.datefrom)
                                .startOf("day")
                                .unix(),
                            dateto: moment(this.dateto)
                                .endOf("day")
                                .unix(),
                            jwt: this.$store.getters.jwt,
                        },
                        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
                    };

                    let vm = this;
                    this.$store.dispatch("setIdBusiness", this.idBusiness);
                    this.axios
                        .get(
                            this.$store.getters.apiUrl + "sales/getDesglosesImpuestos",
                            config
                        )
                        .then(function (response) {
                            if (response.data.response) {

                                vm.dateInform = response.data.result;
                                vm.respuesta = true;
                            } else if (response.data.response == false && response.data.rangoMayor == true) {
                                swal({
                                    title: "Lo sentimos",
                                    text: response.data.result,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "info",
                                });
                                vm.respuesta = false;
                            } else {
                                swal({
                                    title: vm.$t("atencion"),
                                    text: response.data.message,
                                    confirmButtonClass: "btn btn-info btn-fill",
                                    type: "error",
                                });

                                vm.respuesta = false;
                            }
                            vm.loading.close();
                        })
                        .catch(function (error) {
                            console.log(error);
                        });
                }
            }
        },
        getClassDay(date) {
            var classDay = "";
            var humanDate = moment.unix(date);
            var dia = moment(humanDate).format("d");

            if (dia === "0") {
                classDay = "sunday";
            } else if (dia == 5 || dia == 6) {
                classDay = "fridaySaturday";
            }

            return classDay;
        },
    },
};
</script>

<style scoped>
a li {
    color: #111;
}

.card {
    padding: 20px;
}

.div-export {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/DesglosesImpuestos.vue